import Icon from '../../../../baseComponents/gui/icon/Icon';

export default function Gifts({ gifts, price }) {
  return (
    (gifts || price) && (
      <div className={'button__gifts button_transparent custom-button__gifts'}>
        <Icon name={'gifts'} />
      </div>
    )
  );
}
